import { render, staticRenderFns } from "./skin-settings.vue?vue&type=template&id=72bbccf8&"
import script from "./skin-settings.vue?vue&type=script&lang=js&"
export * from "./skin-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports